/**
 * bannerTracking — يرسل أحداث view/click للبانرات إلى السيرفر.
 * - view واحد لكل (banner_id, session_id) — مضمون بـunique index.
 * - click يُسجَّل دائماً.
 * - يتجاهل الأخطاء بصمت لئلّا يكسر تجربة الزائر.
 */
import * as React from "react";
import { getSessionId } from "@/lib/activityTracker";

function getMarket(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem("lux-locale-v3");
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { market?: unknown };
    return typeof parsed.market === "string" ? parsed.market : null;
  } catch {
    return null;
  }
}


// نمنع تكرار view خلال نفس صفحة (in-memory) — الـunique index يحمي حالات أخرى.
const seenViews = new Set<string>();

async function trackBannerEvent(payload: {
  bannerId: string;
  eventType: "view" | "click";
  sessionId: string | null;
  market: string | null;
  triggerValue: string | null;
}) {
  await fetch("/api/banners", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });
}

export function useBannerTracking() {
  const view = React.useCallback(
    async (bannerId: string, triggerValue: string | null) => {
      if (seenViews.has(bannerId)) return;
      seenViews.add(bannerId);
      try {
        await trackBannerEvent({
          bannerId,
          eventType: "view",
          sessionId: getSessionId() || null,
          market: getMarket(),
          triggerValue,
        });
      } catch {
        /* ignore */
      }
    },
    [],
  );

  const click = React.useCallback(
    async (bannerId: string, triggerValue: string | null) => {
      try {
        await trackBannerEvent({
          bannerId,
          eventType: "click",
          sessionId: getSessionId() || null,
          market: getMarket(),
          triggerValue,
        });
      } catch {
        /* ignore */
      }
    },
    [],
  );

  return { view, click };
}
